import { render, staticRenderFns } from "./ShipmentOrderDetailView.vue?vue&type=template&id=2c41580e"
import script from "./ShipmentOrderDetailView.vue?vue&type=script&lang=js"
export * from "./ShipmentOrderDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports